module.exports = __webpack_public_path__ + "img/social-sharow-left.f2a65ef.png";